import { G, Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Map_Marker: React.FC<Props> = ({ fill }) => {
    return (
        <Svg width="12pt" height="100%" viewBox="0 0 32 32" fill={fill}>
            <G id="location-2" data-name="location">
                <Path d="m16 3.81247a7.56041 7.56041 0 0 0 -7.56275 7.56269c0 4.99272 5.62693 14.16914 7.17351 16.597a.45828.45828 0 0 0 .77756-.00057c1.54528-2.43347 7.17443-11.63837 7.17443-16.59644a7.56041 7.56041 0 0 0 -7.56275-7.56268zm0 11.52464a4.08573 4.08573 0 1 1 4.08576-4.08575 4.09509 4.09509 0 0 1 -4.08576 4.08575z" />
            </G>
        </Svg>
    );
};

export default Map_Marker;
